/**
 * Panel admina > SFD B2B > "Skrypt Gmail - pliki z Twojej skrzynki bez hasla"
 * (ANEKS 5). Wlasciciel nie podaje hasla do skrzynki: jego Gmail (Apps Script)
 * sam wysyla zalaczniki z maili SFD do V3SYS z jednorazowym kluczem.
 *
 * Klucz jest pokazywany RAZ (serwer trzyma tylko hash). Skrypt przychodzi z
 * GET /wplyw/skrypt z podstawionym URL; swiezo wygenerowany klucz podstawiamy
 * lokalnie w miejsce placeholdera KLUCZ = 'WKLEJ-TU-KLUCZ-Z-V3SYS'.
 */
import React, { useState, useEffect, useCallback } from 'react';
import { kontrolaFakturService } from '../../services/kontrolaFakturService';
import { formatujDateCzas } from '../kontrola-faktur/format';

export const PLACEHOLDER_KLUCZA = 'WKLEJ-TU-KLUCZ-Z-V3SYS';

/** Podstawia klucz w tresci skryptu: najpierw placeholder, potem dowolna linia KLUCZ = '...'. */
export const podstawKlucz = (skrypt, klucz) => {
  if (!skrypt || !klucz) return skrypt || '';
  if (skrypt.includes(`'${PLACEHOLDER_KLUCZA}'`)) return skrypt.split(`'${PLACEHOLDER_KLUCZA}'`).join(`'${klucz}'`);
  if (skrypt.includes(`"${PLACEHOLDER_KLUCZA}"`)) return skrypt.split(`"${PLACEHOLDER_KLUCZA}"`).join(`"${klucz}"`);
  return skrypt.replace(/(KLUCZ\s*=\s*)(['"])[^'"]*\2/, (m, prefiks, cudz) => `${prefiks}${cudz}${klucz}${cudz}`);
};

/** Kopiowanie do schowka z zapasem na starsze przegladarki / brak HTTPS. */
const kopiujDoSchowka = async (tekst) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(tekst);
      return true;
    }
  } catch (e) { /* sprobuj zapasu */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = tekst;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand && document.execCommand('copy');
    document.body.removeChild(ta);
    return Boolean(ok);
  } catch (e) {
    return false;
  }
};

const WYNIKI = {
  podpiety: { etykieta: 'podpięty', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  juz_jest: { etykieta: 'już był', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  w_systemie: { etykieta: 'już w systemie', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  poczekalnia: { etykieta: 'poczekalnia', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  nieznany_numer: { etykieta: 'nieznany numer', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
  pominiety: { etykieta: 'pominięty (XML z maila, format OSOZ)', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  blad: { etykieta: 'błąd', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
};

const btn = (tlo, kolor, ramka) => ({ padding: '6px 12px', fontSize: '12px', fontWeight: 600, borderRadius: '4px', cursor: 'pointer', border: `1px solid ${ramka}`, background: tlo, color: kolor });
const btnMaly = (tlo, kolor, ramka) => ({ ...btn(tlo, kolor, ramka), padding: '4px 10px', fontSize: '11px' });
const th = { padding: '5px 8px', textAlign: 'left', borderBottom: '2px solid var(--border)', fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' };
const td = { padding: '4px 8px', borderBottom: '1px solid var(--border)', fontSize: '11px', verticalAlign: 'top' };

/**
 * Ocena pulsu skryptu: skrypt melduje sie po KAZDYM przebiegu (co godzine), wiec brak
 * meldunku od ponad 2 h znaczy, ze nie chodzi (wyzwalacz padl, blad w Apps Script)
 * - niezaleznie od tego, czy byly jakies maile. Stara wersja skryptu w skrzynce
 * (bez pulsu albo z nizszym numerem) pomija odpowiedzi Renomy w starych watkach.
 */
export const ocenPuls = (status, teraz = Date.now()) => {
  const wymagana = status.wersja_skryptu;
  if (!status.ma_klucz) return null;
  if (!status.puls) {
    return { poziom: 'ostrzezenie', tekst: `Skrypt jeszcze się nie zameldował. Jeśli wkleiłeś go przed 12.09.2026, wklej nową wersję ${wymagana ?? ''} (w każdej skrzynce, w której działa) — stara pomija paragony przysyłane w odpowiedzi na wcześniejsze maile.` };
  }
  const czas = new Date(status.puls).getTime();
  const godzin = Number.isFinite(czas) ? (teraz - czas) / 3600000 : null;
  if (godzin !== null && godzin > 2) {
    return { poziom: 'blad', tekst: `Skrypt nie odezwał się od ${formatujDateCzas(status.puls)} (ponad ${Math.floor(godzin)} h). Sprawdź w Apps Script menu „Wyzwalacze” i „Wykonania”, albo uruchom ręcznie wyslijDoV3SYS.` };
  }
  const wersja = Number(status.puls_info?.wersja);
  if (wymagana && Number.isFinite(wersja) && wersja < wymagana) {
    return { poziom: 'ostrzezenie', tekst: `W skrzynce działa skrypt w wersji ${wersja}, aktualna to ${wymagana}. Wklej nową wersję (przycisk „Kopiuj skrypt”), przepisując KLUCZ ze starej.` };
  }
  return { poziom: 'ok', tekst: `Skrypt żyje: ostatni puls ${formatujDateCzas(status.puls)}${Number.isFinite(wersja) ? `, wersja ${wersja}` : ''}${status.puls_info?.wyslane !== undefined ? `, w ostatnim przebiegu wysłał ${status.puls_info.wyslane} plików` : ''}.` };
};

const KROKI = [
  'Otwórz script.google.com na koncie, na które przychodzą maile SFD.',
  'Kliknij „Nowy projekt”.',
  'Wklej skrypt (przycisk „Kopiuj skrypt” obok) w miejsce domyślnej treści i zapisz.',
  'Wpisz klucz w stałej KLUCZ (jeśli skopiowałeś skrypt po wygenerowaniu klucza, jest już wpisany).',
  'Uruchom raz funkcję ustawWyzwalacz — Google poprosi o zgodę na dostęp skryptu do Gmaila i internetu; to Twój skrypt, zatwierdź.',
  'Uruchom ręcznie wyslijDoV3SYS, żeby sprawdzić — w tej sekcji pojawi się „ostatni wpływ” i „puls” skryptu.',
  'Masz skrypt w dwóch skrzynkach? Powtórz kroki w każdej. Aktualizacja: otwórz stary projekt, zastąp całą treść nową, przepisz KLUCZ ze starej wersji.',
];

const SfdWplywGmail = () => {
  const [status, setStatus] = useState({ ma_klucz: false, od: null, ostatni: null, ostatnie: [], puls: null, puls_info: {}, wersja_skryptu: null });
  const [skrypt, setSkrypt] = useState('');
  const [nowyKlucz, setNowyKlucz] = useState(null);   // pokazywany RAZ
  const [ladowanie, setLadowanie] = useState(true);
  const [praca, setPraca] = useState(false);
  const [komunikat, setKomunikat] = useState(null);
  const [potwierdzenie, setPotwierdzenie] = useState(null);   // 'generuj' | 'uniewaznij' | null

  const ladujStatus = useCallback(async () => {
    try {
      const dane = await kontrolaFakturService.wplywStatus();
      if (dane) setStatus({
        ma_klucz: Boolean(dane.ma_klucz), od: dane.od || null, ostatni: dane.ostatni || null,
        ostatnie: Array.isArray(dane.ostatnie) ? dane.ostatnie : [],
        puls: dane.puls || null, puls_info: (dane.puls_info && typeof dane.puls_info === 'object') ? dane.puls_info : {},
        wersja_skryptu: dane.wersja_skryptu ?? null,
      });
    } catch (err) {
      if (!err?.isAuthError && !err?.isPermissionError) setKomunikat({ typ: 'blad', tekst: err?.message || 'Nie można pobrać stanu klucza' });
    }
  }, []);

  useEffect(() => {
    let aktywny = true;
    (async () => {
      try {
        const [, tresc] = await Promise.all([
          ladujStatus(),
          kontrolaFakturService.wplywSkrypt().catch(() => ''),
        ]);
        if (aktywny) setSkrypt(typeof tresc === 'string' ? tresc : '');
      } finally {
        if (aktywny) setLadowanie(false);
      }
    })();
    return () => { aktywny = false; };
  }, [ladujStatus]);

  const generuj = async () => {
    setPotwierdzenie(null);
    setPraca(true);
    setKomunikat(null);
    try {
      const wynik = await kontrolaFakturService.wplywKluczGeneruj();
      if (!wynik?.klucz) throw new Error('Serwer nie zwrócił klucza');
      setNowyKlucz(wynik.klucz);
      setStatus(prev => ({ ...prev, ma_klucz: true, od: wynik.od || new Date().toISOString() }));
      setKomunikat({ typ: 'ok', tekst: 'Wygenerowano nowy klucz. Skopiuj go teraz — po odświeżeniu strony nie da się go odczytać ponownie.' });
      await ladujStatus();
    } catch (err) {
      setKomunikat({ typ: 'blad', tekst: err?.message || 'Nie udało się wygenerować klucza' });
    } finally {
      setPraca(false);
    }
  };

  const uniewaznij = async () => {
    setPotwierdzenie(null);
    setPraca(true);
    setKomunikat(null);
    try {
      await kontrolaFakturService.wplywKluczUniewaznij();
      setNowyKlucz(null);
      setStatus(prev => ({ ...prev, ma_klucz: false, od: null }));
      setKomunikat({ typ: 'ok', tekst: 'Klucz unieważniony — skrypt w Gmailu przestał działać, dopóki nie wpiszesz nowego klucza.' });
      await ladujStatus();
    } catch (err) {
      setKomunikat({ typ: 'blad', tekst: err?.message || 'Nie udało się unieważnić klucza' });
    } finally {
      setPraca(false);
    }
  };

  const kopiuj = async (tekst, co) => {
    const ok = await kopiujDoSchowka(tekst);
    setKomunikat(ok ? { typ: 'ok', tekst: `Skopiowano ${co} do schowka.` } : { typ: 'blad', tekst: `Nie udało się skopiować — zaznacz ${co} i skopiuj ręcznie.` });
  };

  const skryptDoPokazania = nowyKlucz ? podstawKlucz(skrypt, nowyKlucz) : skrypt;
  const ostatnie = status.ostatnie || [];

  return (
    <div data-testid="sekcja-wplyw" style={{ backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: '6px', padding: '12px', marginBottom: '1rem', fontSize: '12px' }}>
      <h3 style={{ margin: '0 0 4px', fontSize: '13px', fontWeight: 600 }}>Skrypt Gmail — pliki z Twojej skrzynki bez hasła</h3>
      <p style={{ margin: '0 0 10px', fontSize: '11px', color: 'var(--text-muted)' }}>
        Zamiast hasła do skrzynki: mały skrypt w Twoim Gmailu (Google Apps Script) sam wysyła załączniki z maili SFD do V3SYS.
        Serwer dostaje tylko pliki, z kluczem, który pozwala wyłącznie dodać plik do kontroli faktur. Nic w skrzynce nie jest kasowane ani oznaczane jako przeczytane.
      </p>

      {komunikat && (
        <div data-testid="wplyw-komunikat" style={{
          padding: '8px 12px', marginBottom: '10px', borderRadius: '4px',
          backgroundColor: komunikat.typ === 'ok' ? 'var(--success-light)' : 'var(--danger-light)',
          color: komunikat.typ === 'ok' ? 'var(--success)' : 'var(--danger)',
        }}>
          {komunikat.tekst}
        </div>
      )}

      {/* Puls skryptu */}
      {(() => {
        const puls = ladowanie ? null : ocenPuls(status);
        if (!puls) return null;
        const kolory = { ok: ['var(--success-light)', 'var(--success)'], ostrzezenie: ['var(--warning-light)', 'var(--warning)'], blad: ['var(--danger-light)', 'var(--danger)'] }[puls.poziom];
        return (
          <div data-testid="wplyw-puls" data-poziom={puls.poziom} style={{ padding: '8px 10px', borderRadius: '4px', marginBottom: '8px', backgroundColor: kolory[0], border: `1px solid ${kolory[1]}`, color: kolory[1], fontWeight: 600 }}>
            {puls.tekst}
          </div>
        );
      })()}

      {/* Stan klucza */}
      <div data-testid="wplyw-stan" style={{
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', padding: '8px 10px', borderRadius: '4px', marginBottom: '10px',
        backgroundColor: status.ma_klucz ? 'var(--success-light)' : 'var(--bg)',
        border: `1px solid ${status.ma_klucz ? 'var(--success)' : 'var(--border)'}`,
      }}>
        <span style={{ fontWeight: 600, color: status.ma_klucz ? 'var(--success)' : 'var(--text-secondary)' }}>
          {ladowanie
            ? 'Sprawdzam stan klucza…'
            : status.ma_klucz
              ? <>Klucz aktywny od {formatujDateCzas(status.od)}, ostatni wpływ {status.ostatni ? formatujDateCzas(status.ostatni) : 'jeszcze nie było'}</>
              : 'Brak klucza — skrypt nie może wysyłać plików'}
        </span>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
          <button type="button" data-testid="btn-generuj-klucz" disabled={praca || ladowanie}
            onClick={() => (status.ma_klucz ? setPotwierdzenie('generuj') : generuj())}
            style={{ ...btn('var(--primary)', '#fff', 'var(--primary)'), opacity: praca || ladowanie ? 0.6 : 1 }}>
            {praca ? 'Pracuję…' : status.ma_klucz ? 'Wygeneruj nowy klucz' : 'Wygeneruj klucz'}
          </button>
          {status.ma_klucz && (
            <button type="button" data-testid="btn-uniewaznij-klucz" disabled={praca}
              onClick={() => setPotwierdzenie('uniewaznij')}
              style={{ ...btn('var(--card-bg)', 'var(--danger)', 'var(--danger)'), opacity: praca ? 0.6 : 1 }}>
              Unieważnij klucz
            </button>
          )}
        </span>
      </div>

      {potwierdzenie && (
        <div data-testid="wplyw-potwierdzenie" style={{ padding: '8px 10px', marginBottom: '10px', borderRadius: '4px', backgroundColor: 'var(--warning-light)', border: '1px solid var(--warning)', color: 'var(--text)' }}>
          {potwierdzenie === 'generuj'
            ? 'Poprzedni klucz przestanie działać — skrypt w Gmailu trzeba będzie zaktualizować nowym kluczem. Wygenerować nowy?'
            : 'Unieważnić klucz? Skrypt w Gmailu przestanie wysyłać pliki, dopóki nie wygenerujesz i nie wpiszesz nowego.'}
          <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
            <button type="button" data-testid="btn-potwierdz" onClick={potwierdzenie === 'generuj' ? generuj : uniewaznij}
              style={btnMaly(potwierdzenie === 'generuj' ? 'var(--primary)' : 'var(--danger)', '#fff', potwierdzenie === 'generuj' ? 'var(--primary)' : 'var(--danger)')}>
              {potwierdzenie === 'generuj' ? 'Tak, wygeneruj nowy' : 'Tak, unieważnij'}
            </button>
            <button type="button" onClick={() => setPotwierdzenie(null)} style={btnMaly('var(--card-bg)', 'var(--text)', 'var(--border)')}>Anuluj</button>
          </div>
        </div>
      )}

      {/* Klucz - pokazany RAZ */}
      {nowyKlucz && (
        <div data-testid="wplyw-nowy-klucz" style={{ padding: '10px', marginBottom: '10px', borderRadius: '4px', backgroundColor: 'var(--warning-light)', border: '1px solid var(--warning)' }}>
          <div style={{ fontWeight: 600, color: 'var(--warning)', marginBottom: '6px' }}>
            {'⚠️'} Twój nowy klucz — widzisz go tylko teraz. Po odświeżeniu strony nie da się go odczytać ponownie (serwer trzyma tylko jego skrót).
          </div>
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
            <input type="text" readOnly value={nowyKlucz} aria-label="Nowy klucz" onFocus={(e) => e.target.select()}
              style={{ flex: '1 1 320px', padding: '6px 8px', fontSize: '12px', fontFamily: 'monospace', border: '1px solid var(--border)', borderRadius: '4px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }} />
            <button type="button" data-testid="btn-kopiuj-klucz" onClick={() => kopiuj(nowyKlucz, 'klucz')} style={btnMaly('var(--primary)', '#fff', 'var(--primary)')}>Kopiuj</button>
          </div>
        </div>
      )}

      {/* Skrypt + instrukcja */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '12px', marginBottom: '10px' }}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <label htmlFor="wplyw-skrypt" style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-secondary)' }}>
              Gotowy skrypt{nowyKlucz ? ' (z wpisanym nowym kluczem)' : ' (klucz wpiszesz w KLUCZ)'}
            </label>
            <button type="button" data-testid="btn-kopiuj-skrypt" disabled={!skryptDoPokazania}
              onClick={() => kopiuj(skryptDoPokazania, 'skrypt')} style={btnMaly('var(--card-bg)', 'var(--primary)', 'var(--primary)')}>
              Kopiuj skrypt
            </button>
          </div>
          <textarea id="wplyw-skrypt" readOnly value={skryptDoPokazania} spellCheck={false}
            placeholder={ladowanie ? 'Pobieram skrypt…' : 'Skrypt niedostępny — backend nie udostępnił /wplyw/skrypt'}
            style={{ width: '100%', minHeight: '220px', padding: '8px', fontSize: '11px', fontFamily: 'monospace', lineHeight: 1.4, border: '1px solid var(--border)', borderRadius: '4px', backgroundColor: 'var(--bg)', color: 'var(--text)', resize: 'vertical', boxSizing: 'border-box' }} />
        </div>
        <div>
          <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '4px' }}>Jak to uruchomić (7 kroków)</div>
          <ol data-testid="wplyw-instrukcja" style={{ margin: 0, paddingLeft: '18px', fontSize: '11px', color: 'var(--text)', lineHeight: 1.6 }}>
            {KROKI.map((k, i) => <li key={i}>{k}</li>)}
          </ol>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px' }}>
            Skrypt działa co godzinę pod Twoim kontem Google, wysyła tylko załączniki .xml/.zip/.pdf z maili SFD z ostatnich 14 dni, pamięta każdą wysłaną wiadomość z osobna (etykieta „V3SYS-wyslane” jest tylko dla Ciebie) i po każdym przebiegu melduje się tutaj pulsem.
          </div>
        </div>
      </div>

      {/* Ostatnie wplywy */}
      <div>
        <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: '4px' }}>Ostatnie wpływy</div>
        {ostatnie.length === 0 ? (
          <div data-testid="wplyw-pusto" style={{ fontSize: '11px', color: 'var(--text-muted)' }}>Jeszcze nic nie przyszło ze skryptu.</div>
        ) : (
          <div style={{ overflow: 'auto' }}>
            <table data-testid="wplyw-tabela" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={th}>Kiedy</th>
                  <th style={th}>Temat</th>
                  <th style={th}>Plik</th>
                  <th style={th}>Numer</th>
                  <th style={th}>Wynik</th>
                </tr>
              </thead>
              <tbody>
                {ostatnie.map((w, i) => {
                  const s = WYNIKI[w.wynik] || { etykieta: w.wynik || '—', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' };
                  return (
                    <tr key={w.id ?? `${w.kiedy}-${i}`} data-testid="wplyw-wiersz">
                      <td style={{ ...td, whiteSpace: 'nowrap' }}>{formatujDateCzas(w.kiedy)}</td>
                      <td style={{ ...td, maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={w.nadawca ? `${w.temat || ''} — ${w.nadawca}` : (w.temat || '')}>{w.temat || '—'}</td>
                      <td style={{ ...td, fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{w.nazwa_pliku || '—'}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap', fontWeight: 600 }}>{w.numer || <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>—</span>}</td>
                      <td style={td}>
                        <span title={w.komunikat || undefined} style={{ display: 'inline-block', padding: '1px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600, color: s.kolor, backgroundColor: s.tlo, whiteSpace: 'nowrap', cursor: w.komunikat ? 'help' : 'default' }}>
                          {s.etykieta}
                        </span>
                        {/* ANEKS 6e: PDF wydruku paragonu dopiety do XML z tego samego maila - powod widoczny bez tooltipa */}
                        {w.komunikat && /^PDF paragonu/i.test(w.komunikat) && (
                          <span data-testid="wplyw-pdf-paragonu" style={{ display: 'block', fontSize: '10px', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                            {w.komunikat}
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SfdWplywGmail;
